<template>
  <div class="">
    <div class="card text-left p-2 border-0 shadow">
      <h5 @click="showModal()" v-if="offeredAnalysis.length < 2">
        UNASSIGNED ANALYSIS: <b> {{ offeredAnalysis.length }}</b>
      </h5>
      <h5 @click="showModal()" v-else>
        UNASSIGNED ANALYSES: <b> {{ offeredAnalysis.length }}</b>
      </h5>
    </div>

    <!-- Modal -->
    <div
      class="modal fade set-width"
      id="offeredAnalysisModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="offeredAnalysisModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="offeredAnalysisModalLabel">
              <b>Assign campaign.s to product</b>
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body p-2">
            <div class="container-fluid justify-content-around">
              <form class="card border-0">
                <div
                  v-for="(value, key) in offeredAnalysis"
                  class="row pb-3"
                  :key="key"
                >
                  <div class="col">
                    <label for="campaignsId" v-if="key === 0"
                      >Campaigns ID</label
                    >
                    <input
                      type="text"
                      class="form-control-plaintext"
                      id="campaignsId"
                      v-model="offeredAnalysis[key]['ID']"
                      readonly
                      style="text-align: center"
                    />
                  </div>
                  <div class="col">
                    <label for="productId" v-if="key === 0">Product</label>
                    <select
                      name=""
                      id="productId"
                      class="form-select"
                      v-model="offeredAnalysis[key]['ProductId']"
                      v-on:change="updateProductUseInput(key)"
                    >
                      <option
                        v-for="(value, key) in products"
                        :key="key"
                        :value="value.ID"
                      >
                        {{ value.ProductName }} | ({{
                          Object.keys(value).includes(
                            "ManDaysTotal",
                            "ManDaysUsed",
                          )
                            ? value.ManDaysTotal - value.ManDaysUsed
                            : "0"
                        }}) | ({{ value.ID }})
                      </option>
                    </select>
                  </div>
                  <div class="col">
                    <label for="productUse" v-if="key === 0">Usage</label>
                    <select
                      name=""
                      id="productUse"
                      class="form-select"
                      v-model="offeredAnalysis[key]['ManDaysUsed']"
                    >
                      <option
                        :key="value"
                        v-bind:value="value"
                        v-for="(value, key) in manDays"
                      >
                        {{ key }}
                      </option>
                    </select>
                  </div>
                </div>
                <p style="color: #ff0000">
                  {{ entriesStore.offeredAnalysisErrorMsg }}
                </p>
                <div class="d-flex justify-content-center form-margin">
                  <button
                    type="button"
                    class="btn btn-primary"
                    :disabled="isUserKam"
                    @click="submitOfferedForm()"
                    data-dismiss="modal"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useUserStore } from "@/stores/user";

const { checkIfUserIsKam } = useUserStore;
const isUserKam = useUserStore().checkIfUserIsKam();
</script>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  props: ["offeredAnalysis", "clientProducts", "entriesStore"],
  data() {
    return {
      manDays: {
        "0.25 day": 0.25,
        "0.5 day": 0.5,
        "1 day": 1,
        "1.5 day": 1.5,
        "2 days": 2,
        "3 days": 3,
        "4 days": 4,
        "5 days": 5,
        "6 days": 6,
      },
      products: [],
    };
  },
  methods: {
    showModal() {
      if (this.products.length === 0) {
        this.clientProducts.forEach((item) => {
          if (item.ID > 0) {
            this.products.push(item);
          }
        });
      }
      $("#offeredAnalysisModal").modal("show");
    },
    submitOfferedForm() {
      this.entriesStore.updateOfferedAnalysis();
      this.$emit("submitOfferedForm");
    },
    getProductName(productId) {
      let productName = "";
      this.products.forEach((item) => {
        if (item.id === productId) {
          productName = item.product_name;
        }
      });
      return productName;
    },
    chooseWhichConsummationToDisplay(key) {
      let currProductName = this.getProductName(
        this.offeredAnalysis[key]["productId"],
      );
      if (currProductName === "Man-days") {
        return 1;
      } else if (
        (!currProductName.includes("credits") ||
          !currProductName.includes("Credit") ||
          !currProductName.includes("credits") ||
          !currProductName.includes("Credit")) &&
        (currProductName.includes("Campaigns") ||
          currProductName.includes("Campaign") ||
          currProductName.includes("campaigns") ||
          currProductName.includes("campaign"))
      ) {
        this.offeredAnalysis[key]["productUse"] = 1;
        return 3;
      }
    },
    updateProductUseInput(key) {
      this.chooseWhichConsummationToDisplay(key);
    },
    isProductNameManDays(item) {
      return item.product_name === "Man-days";
    },
    isProductNameCampaigns(item) {
      return (
        !this.isProductNameCredits(item) &&
        (item.product_name.includes("Campaigns") ||
          item.product_name.includes("Campaign") ||
          item.product_name.includes("campaigns") ||
          item.product_name.includes("campaign"))
      );
    },
    isProductNameCredits(item) {
      return (
        item.product_name.includes("credits") ||
        item.product_name.includes("Credit") ||
        item.product_name.includes("credits") ||
        item.product_name.includes("Credit")
      );
    },
  },
});
</script>

<style>
h5:hover {
  cursor: pointer;
}
</style>
